export default {
  row: 'Rangée',
  rows: 'Rangées',
  verbose_row: 'une rangée',
  general_info: 'Informations générales',

  columns: 'Colonnes',
  layout: 'Disposition',
  gutters: 'Enlever marges entre les éléments de la grille',
  contained: 'Centrer la rangée dans la page avec largeur maximale',
};
